import { render, staticRenderFns } from "./DetailsModal.vue?vue&type=template&id=54133a4a&scoped=true&lang=pug"
import script from "./DetailsModal.vue?vue&type=script&lang=js"
export * from "./DetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54133a4a",
  null
  
)

export default component.exports